import { formatPriceToEuroString } from './format-price';

export const priceComponents = (amount:number) => {
  const [euros, cents] = formatPriceToEuroString(amount).substring(1).split(',');
  return { euros, cents };
};
